import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import * as React from 'react';

import Agreement from '../models/Agreement';

export interface Props {
  onClick: (name: string) => void;

  isSelected: boolean;
  agreement: Agreement;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    row: {
      cursor: 'pointer'
    },
    cell: {
      padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
      maxWidth: '320px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    chip: {
      width: '100%',
      cursor: 'inherit'
    },
    active: {
      backgroundColor: theme.palette.active.main
    },
    cancelled: {
      backgroundColor: theme.palette.cancelled.main
    },
    proposed: {
      backgroundColor: theme.palette.proposed.main
    }
  })
);

const AgreementsTableRow: React.FC<Props> = ({
  onClick,
  isSelected,
  agreement: {
    id,
    name,
    status,
    facility,
    fileNumber,
    companyName,
    agreementDate,
    initialAgreementCovers,
    notes,
    pipelineDiameter,
    pipelineProduct,
    pipelineLength
  }
}) => {
  const classes = useStyles();

  function TableCellSpan({ children, ...tableCellProps }) {
    return (
      <TableCell className={classes.cell} {...tableCellProps}>
        <Typography component="span" noWrap={true}>
          {children}
        </Typography>
      </TableCell>
    );
  }

  return (
    <TableRow
      className={classes.row}
      hover={true}
      onClick={onClick.bind(null, id)}
      selected={isSelected}
    >
      <TableCellSpan>{name}</TableCellSpan>
      <TableCell className={classes.cell}>
        <Chip
          label={status}
          className={clsx(classes.chip, {
            [classes.active]: status === 'Active',
            [classes.cancelled]: status === 'Cancelled',
            [classes.proposed]: status === 'Proposed'
          })}
        />
      </TableCell>
      <TableCellSpan>{facility}</TableCellSpan>
      <TableCellSpan align="center">{fileNumber}</TableCellSpan>
      <TableCellSpan>{companyName}</TableCellSpan>
      <TableCellSpan align="center">{agreementDate}</TableCellSpan>
      <TableCellSpan title={initialAgreementCovers}>{initialAgreementCovers}</TableCellSpan>
      <TableCellSpan title={notes}>{notes}</TableCellSpan>
      <TableCellSpan title={pipelineDiameter}>{pipelineDiameter}</TableCellSpan>
      <TableCellSpan title={pipelineProduct}>{pipelineProduct}</TableCellSpan>
      <TableCellSpan title={pipelineLength}>{pipelineLength}</TableCellSpan>
    </TableRow>
  );
};

export default AgreementsTableRow;
